var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"account-page-top-bar"},[(_vm.showBack)?_c('button',{staticClass:"account-page-top-bar__back",attrs:{"type":"button","aria-label":_vm.$t('back')},on:{"click":function($event){return _vm.$emit('back')}}},[_c('Icon',{attrs:{"name":"arrow-left"}})],1):_vm._e(),_c('h1',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }